import { render, staticRenderFns } from "./PresentationPresenters.vue?vue&type=template&id=58f11fac"
import script from "./PresentationPresenters.vue?vue&type=script&lang=ts"
export * from "./PresentationPresenters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports